import React, { useEffect, useRef, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import "./Pages/PagesCss/NavBar.css";

const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "Blog", to: "https://blog.d-techstudios.com", external: true },
  { label: "Showcase",    to: "/Showcase"    },
];

export default function Navbar() {
  const [scrolled,  setScrolled]  = useState(false);
  const [menuOpen,  setMenuOpen]  = useState(false);
  const location = useLocation();
  const overlayRef = useRef(null);

  /* ── scroll shadow ── */
  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", fn, { passive: true });
    return () => window.removeEventListener("scroll", fn);
  }, []);

  /* ── close on route change ── */
  useEffect(() => { setMenuOpen(false); }, [location.pathname]);

  /* ── lock body scroll ── */
  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [menuOpen]);

  /* ── close on overlay backdrop click ── */
  const handleOverlayClick = (e) => {
    if (e.target === overlayRef.current) setMenuOpen(false);
  };

  return (
    <>
      {/* ════════════ NAVBAR BAR ════════════ */}
      <header className={`nb ${scrolled ? "nb--scrolled" : ""}`}>
        <div className="nb__inner">

          {/* LOGO */}
          <NavLink to="/" className="nb__logo" aria-label="D-TechStudios home">
            <span className="nb__logo-text">D-Tech</span>
            <span className="nb__logo-pill">
              <span className="nb__logo-pill-text">Studios</span>
            </span>
          </NavLink>

          {/* DESKTOP NAV */}
          <nav className="nb__nav" aria-label="Primary navigation">
            {NAV_LINKS.map((link) =>
  link.external ? (
    <a
      key={link.to}
      href={link.to}
      target="_blank"
      rel="noopener noreferrer"
      className="nb__link"
    >
      {link.label}
    </a>
  ) : (
    <NavLink
      key={link.to}
      to={link.to}
      className={({ isActive }) =>
        ["nb__link", isActive ? "nb__link--active" : ""].join(" ").trim()
      }
    >
      {link.label}
    </NavLink>
  )
)}
          </nav>

          {/* DESKTOP CTA */}
          <NavLink to="/products" className="nb__cta">
            Explore Products
            <span className="nb__cta-arrow" aria-hidden="true">→</span>
          </NavLink>

          {/* HAMBURGER — visible only on mobile */}
          <button
            className={`nb__burger ${menuOpen ? "nb__burger--open" : ""}`}
            onClick={() => setMenuOpen((v) => !v)}
            aria-label={menuOpen ? "Close menu" : "Open menu"}
            aria-expanded={menuOpen}
            aria-controls="nb-mobile-panel"
          >
            <span className="nb__bline" />
            <span className="nb__bline" />
            <span className="nb__bline" />
          </button>
        </div>
      </header>

      {/* ════════════ MOBILE DRAWER ════════════ */}
      {/*
        The overlay sits outside <header> so it covers the whole viewport.
        We render it always but toggle visibility via class.
      */}
      <div
        ref={overlayRef}
        id="nb-mobile-panel"
        className={`nb__overlay ${menuOpen ? "nb__overlay--open" : ""}`}
        aria-hidden={!menuOpen}
        onClick={handleOverlayClick}
      >
        <div className="nb__drawer" role="dialog" aria-modal="true" aria-label="Navigation menu">

          {/* drawer top — logo + close */}
          <div className="nb__drawer-top">
            <NavLink to="/" className="nb__logo" onClick={() => setMenuOpen(false)}>
              <span className="nb__logo-text">D-Tech</span>
              <span className="nb__logo-pill">
                <span className="nb__logo-pill-text">Studios</span>
              </span>
            </NavLink>
            <button
              className="nb__drawer-close"
              onClick={() => setMenuOpen(false)}
              aria-label="Close menu"
            >
              ✕
            </button>
          </div>

          {/* drawer links */}
          <nav className="nb__drawer-nav" aria-label="Mobile navigation">
            {NAV_LINKS.map((link, i) => (
              <NavLink
                key={link.to}
                to={link.to}
                className={({ isActive }) =>
                  ["nb__drawer-link", isActive ? "nb__drawer-link--active" : ""].join(" ").trim()
                }
                style={{ animationDelay: menuOpen ? `${0.05 + i * 0.06}s` : "0s" }}
              >
                <span className="nb__drawer-num">0{i + 1}</span>
                <span className="nb__drawer-label">{link.label}</span>
                <span className="nb__drawer-arrow" aria-hidden="true">→</span>
              </NavLink>
            ))}
          </nav>

          {/* drawer footer CTA */}
          <div className="nb__drawer-footer">
            <NavLink
              to="/Products"
              className="nb__cta nb__cta--full"
              onClick={() => setMenuOpen(false)}
            >
              Explore Products
              <span className="nb__cta-arrow" aria-hidden="true">→</span>
            </NavLink>
            <p className="nb__drawer-tagline">Independent AI &amp; SaaS Studio</p>
          </div>
        </div>
      </div>
    </>
  );
}